/**
 * Layout Constants - Single Source of Truth
 * 
 * These values ensure consistent spacing and alignment across the entire app.
 * DO NOT override these values in individual components.
 */

export const LAYOUT = {
  // Sidebar
  SIDEBAR_WIDTH: 256, // 16rem / w-64 in Tailwind
  SIDEBAR_WIDTH_CLASS: 'w-64',
  SIDEBAR_MARGIN_CLASS: 'lg:ml-64',
  
  // Top Header
  HEADER_HEIGHT: 64, // 4rem
  HEADER_HEIGHT_CLASS: 'h-16',
  HEADER_MARGIN_CLASS: 'mt-16',
  
  // Content Padding (internal spacing only, no margin)
  CONTENT_PADDING_MOBILE: 16, // 1rem / p-4
  CONTENT_PADDING_DESKTOP: 24, // 1.5rem / p-6
  CONTENT_PADDING_CLASS: 'p-4 sm:p-6',
  
  // Breakpoints (matching Tailwind)
  BREAKPOINT_MOBILE: 640,
  BREAKPOINT_TABLET: 768,
  BREAKPOINT_DESKTOP: 1024,
};

export default LAYOUT;
